import { pushAnalytics } from '../../utils/analytics/ym';

const ACTIONS = {
  CLICK: 'click',
  VIEW: 'view',
};
const ZONES = {
  NOTIFICATIONS: 'notifications',
  TARIFF: 'tariff',
  BALANCE: 'balance',
};

const pushZoneAnalytics = ({ zone, action, data }) => {
  pushAnalytics({
    [zone]: {
      [action]: data,
    },
  });
};

const pushClickAnalytics = ({ zone, data }) => {
  pushZoneAnalytics({ zone, data, action: ACTIONS.CLICK });
};

const pushViewAnalytics = ({ zone, data }) => {
  pushZoneAnalytics({ zone, data, action: ACTIONS.VIEW });
};

class HomePageAnalytics {
  key;

  constructor(key) {
    this.key = key;
  }

  pushClickEvent(data) {
    pushClickAnalytics({ data, zone: this.key });
  }

  pushViewEvent(data) {
    pushViewAnalytics({ data, zone: this.key });
  }
}

export const notificationsAnalytics = new HomePageAnalytics(ZONES.NOTIFICATIONS);
export const tariffAnalytics = new HomePageAnalytics(ZONES.TARIFF);
export const balanceAnalytics = new HomePageAnalytics(ZONES.BALANCE);
